import { motion, AnimatePresence } from "framer-motion";

const MessagePopup = ({ show, message }) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed bottom-24 left-4 right-4 mx-auto max-w-md z-[9999] pointer-events-auto"
          initial={{ opacity: 0, y: 20, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.95 }}
          transition={{ type: "spring", damping: 25, stiffness: 300 }}
        >
          <div className="bg-white/95 backdrop-blur-md border border-border/50 rounded-2xl shadow-lg px-5 py-4 text-center">
            <p className="text-sm sm:text-base text-foreground font-medium">
              {message}
            </p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MessagePopup;